import React, { useState, useEffect } from 'react';
//import './HeaderSort.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { Popover } from 'react-tiny-popover';

function openFilter(props) {
	const {
		filterKey,
		sortKey,
		sortDirection,
		handleSortClick,
	} = props;



	const getSortIcon = () => {
		if (sortKey !== filterKey) return faSort;
		if (sortDirection === 'ascending') return faSortUp;
		if (sortDirection === 'descending') return faSortDown;
		return faSort;
	};

	return (
		<div className={`header__sort ${filterKey === sortKey ? 'active' : ''}`} onClick={() => handleSortClick(filterKey)}>
				<FontAwesomeIcon icon={getSortIcon()} />
			</div>
	);
}

export default openFilter;
